var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { classNames } from '../../utils';
import styles from './Alert.module.css';
export var AlertType;
(function (AlertType) {
    AlertType["warning"] = "Warning";
})(AlertType || (AlertType = {}));
const Alert = (props) => {
    const { message, type, timeoutAt, startAt, onTimeout } = props, divAttr = __rest(props, ["message", "type", "timeoutAt", "startAt", "onTimeout"]);
    useEffect(() => {
        let timer;
        if (onTimeout && timeoutAt && startAt) {
            timer = setTimeout(onTimeout, timeoutAt - startAt);
        }
        return () => {
            if (timer)
                clearTimeout.bind(null, timer);
        };
    }, [timeoutAt, startAt, onTimeout]);
    return (_jsxs("div", Object.assign({ className: classNames(styles.root, styles[`${type}_root`]) }, divAttr, { children: [_jsxs("span", Object.assign({ className: styles[`${type}_label`] }, { children: [AlertType[type], ":"] }), void 0), message] }), void 0));
};
export default Alert;
